import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { Table, Label, Input } from 'reactstrap';
import ModalPopup from 'components/organisms/modal';
import Button from 'components/atoms/button';
import forms from 'constants/forms';
import { showResult, getInitialValues } from 'utils';

const ORDER_CONSUMABLE_FIELDS = forms.orderConsumableFields;

const OrderConsumableModal = ({
  isOpen,
  toggle,
  patientGuid,
  loading,
  submit,
}) => {
  const [buttonDisabled, setbuttonDisabled] = useState(true);

  const validate = (values) => {
    const allNone = Object.keys(values).every((key) => values[key] === 'none');

    if (allNone || loading) {
      setbuttonDisabled(true);
    } else {
      setbuttonDisabled(false);
    }
  };
  const handleSubmit = async (values) => {
    const orders = Object.keys(values)
      .map((key) =>
        values[key] !== 'none'
          ? {
              name: key,
              type: values[key],
            }
          : null,
      )
      .filter((order) => order);

    const postData = {
      patientGuid,
      orders,
    };
    const { error } = await submit(postData);
    showResult(error, null, toggle);
  };

  return (
    <ModalPopup
      isOpen={isOpen}
      toggle={toggle}
      title="Order Consumable"
      className="popup order-consumable-popup"
    >
      <Formik
        initialValues={getInitialValues(ORDER_CONSUMABLE_FIELDS)}
        onSubmit={handleSubmit}
        validate={validate}
      >
        <Form className="orders-form">
          <Table borderless border="0" cellSpacing="0" cellPadding="0">
            <tbody>
              {ORDER_CONSUMABLE_FIELDS.map((field) => (
                <tr key={field.id}>
                  <td>
                    <Label className="order-consumable-label" for={field.id}>
                      {field.label}
                    </Label>
                  </td>
                  <td>
                    <Field id={field.id} name={field.id} type={field.type}>
                      {({ field: { value }, form: { setFieldValue } }) => (
                        <Input
                          className="order-consumable-select"
                          id={field.id}
                          name={field.id}
                          type={field.type}
                          defaultValue={value}
                          onChange={(e) =>
                            setFieldValue(field.id, e.target.value)
                          }
                        >
                          {field.options.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      )}
                    </Field>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="text-center">
            <Button
              type="submit"
              text="Send"
              disabled={buttonDisabled || loading}
            />
          </div>
        </Form>
      </Formik>
    </ModalPopup>
  );
};
OrderConsumableModal.defaultProps = {
  isOpen: false,
};

OrderConsumableModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  patientGuid: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
};

export default OrderConsumableModal;
